import MaterialRadio from "../../../../__snowpack__/pkg/@mui/material/Radio.js";
import styled from "styled-components";
export const RadioContainer = styled(MaterialRadio).withConfig({
  displayName: "radiostyles__RadioContainer",
  componentId: "sc-1drww1h-0"
})([""]);
